import proxy from "../proxy";
const file = {
  upload:
    (data = {}) =>
    async (dispatch) => {
      var formData = new FormData();
      for (let key in data) formData.append(key, data[key]);
      return await proxy.post(
        "file/upload",
        formData,
        {
          dispatch,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        data
      );
    },
};

export default file;
